import { Button, EButtonType } from '@/components/Button';
import {
    selectVehicleAssetType,
    setIsVehicleRegistrationKnown,
} from '@/context/borrower';
import {
    EDisplays,
    setDisplay,
    setVehicleManualEntry,
} from '@/context/display';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { isCaravan } from '@/utils/glassGuideHelpers';

export function ManualVehicleSearchButtons(): JSX.Element {
    // ***** Redux State *****
    const dispatch = useAppDispatch();
    const assetType = useAppSelector(selectVehicleAssetType);

    function handleRegoClick(): void {
        dispatch(setVehicleManualEntry(false));
        dispatch(setIsVehicleRegistrationKnown(true));
        dispatch(setDisplay(EDisplays.VEHICLE));
    }

    function handleManualClick(): void {
        dispatch(setVehicleManualEntry(false));
        dispatch(setDisplay(EDisplays.VEHICLE));
    }

    return (
        <div>
            <div className='flex space-x-4 pt-3'>
                {!isCaravan(assetType) && (
                    <Button
                        type={EButtonType.SECONDARY_OUTLINE}
                        onClick={handleRegoClick}
                    >
                        Search by Rego
                    </Button>
                )}
                <Button
                    type={EButtonType.SECONDARY_OUTLINE}
                    onClick={handleManualClick}
                >
                    Search Manually
                </Button>
            </div>
        </div>
    );
}
